import { IsEnum, IsNotEmpty, IsOptional, IsString, ValidateIf } from 'class-validator';
import { ExportTypeEnum } from '../../enums';

export class CreateExportFileDto {
	@IsString()
	@IsEnum(ExportTypeEnum)
	exportType: ExportTypeEnum;

	@IsString()
	@IsNotEmpty()
	timezone: string;

	@ValidateIf((dto: CreateExportFileDto) => dto.exportType === ExportTypeEnum.TRADES)
	@IsString()
	@IsNotEmpty()
	eventId: string;

	@ValidateIf((dto: CreateExportFileDto) => dto.exportType === ExportTypeEnum.TRADES)
	@IsOptional()
	@IsString()
	lobbyId?: string;
}
